import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form__range" }
const _hoisted_2 = ["min", "max"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "form__range-background" }, null, -1)
const _hoisted_4 = { class: "form__range-left" }
const _hoisted_5 = { class: "form__range-right" }
const _hoisted_6 = { class: "form__range-output-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "range",
      min: _ctx.min,
      max: _ctx.max,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: "form__range-input"
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.value]
    ]),
    _hoisted_3,
    _createElementVNode("div", {
      class: "form__range-progress",
      style: _normalizeStyle({ width: `${_ctx.percentage}%`} )
    }, null, 4),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.leftDesc), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.rightDesc), 1),
    _createElementVNode("div", {
      class: "form__range-output",
      style: _normalizeStyle({ left: `calc(${_ctx.percentage}% - 1.15rem)`})
    }, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.value > 0 ? '+' + _ctx.value : _ctx.value) + " % ", 1)
    ], 4)
  ]))
}